"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiAutoCompleteSelect = void 0;
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));
var _react = _interopRequireWildcard(require("react"));
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _clsx = _interopRequireDefault(require("clsx"));
var _MultiAutoCompleteSelect = require("./MultiAutoCompleteSelect.styles");
var _excluded = ["label", "placeholder", "rows", "variant", "className", "noChipPadding", "options", "getOptionLabel", "onChange"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultGetOptionLabel = function defaultGetOptionLabel(option) {
  return option.label;
};
var MultiAutoCompleteSelect = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var label = _ref.label,
    placeholder = _ref.placeholder,
    rows = _ref.rows,
    variant = _ref.variant,
    className = _ref.className,
    noChipPadding = _ref.noChipPadding,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$getOptionLabel = _ref.getOptionLabel,
    getOptionLabel = _ref$getOptionLabel === void 0 ? defaultGetOptionLabel : _ref$getOptionLabel,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var classes = (0, _MultiAutoCompleteSelect.useStyles)();
  var renderInput = (0, _react.useCallback)(function (params) {
    return /*#__PURE__*/_react["default"].createElement(_TextField["default"], _extends({}, params, {
      variant: variant || 'standard',
      label: label,
      placeholder: placeholder,
      multiline: !!rows,
      rows: rows,
      InputLabelProps: {
        shrink: rows ? false : undefined
      },
      className: (0, _clsx["default"])(rows ? classes.textField : '', noChipPadding ? classes.thinTextField : '', className)
    }));
  }, [placeholder, label, rows, variant]);
  var autocomplete = /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
    multiple: true,
    options: options,
    getOptionLabel: getOptionLabel,
    onChange: onChange,
    renderInput: renderInput,
    placeholder: placeholder
  }, rest));
  if (rows) {
    autocomplete = /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], _extends({
      multiple: true,
      disableClearable: true,
      placeholder: placeholder,
      options: options,
      getOptionLabel: getOptionLabel,
      forcePopupIcon: false,
      onChange: onChange,
      renderInput: renderInput
    }, rest, {
      ChipProps: {
        className: noChipPadding ? classes.chips : classes.paddedChips,
        deleteIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: _proSolidSvgIcons.faCircleXmark,
          className: classes.deleteIcon
        })
      }
    }));
  }
  return autocomplete;
});
exports.MultiAutoCompleteSelect = MultiAutoCompleteSelect;